RivalIQ.apps.Reports.module('widgets', function (widgets, App, Backbone, Marionette, $, _, s, moment) {

    'use strict';

    const EditModal = Marionette.LayoutView.extend({
        template: '#reportsScheduledReportEditTemplate',

        regions: {
            emailInput: '.x-email-input',
            advanced: '.x-advanced-settings-region'
        },

        ui: {
            saveBtn: '.x-save',
            modal: '.modal',
            titleForm: '.title-form',
            formatForm: '.format-form'
        },

        events: {
            'click @ui.saveBtn': 'onSave',
            'change @ui.titleForm': 'onTitleChange',
            'change @ui.formatForm': 'onFormatChange'
        },

        behaviors: {
            AttributeBuilder: {},
            FormValidator: {}
        },

        onTitleChange: function () {
            const me = this;
            me.reportCopy.set({
                title: me.ui.titleForm.val()
            });
        },

        onFormatChange: function (e) {
            const me = this;
            const $el = $(e.currentTarget);
            const selectedFormat = $el.val();
            me.reportCopy.set({
                format: selectedFormat
            });
        },

        onSave: function () {
            const me = this;
            me.ui.saveBtn.button('loading');

            const report = me.model.get('report');
            const advanced = me.model.get('advanced');

            // apply changes to models
            report.set({
                title: me.reportCopy.get('title'),
                emails: me.emailsCopy,
                format: me.reportCopy.get('format')
            });

            advanced.set({
                focusCompanyId: me.advancedCopy.get('focusCompanyId'),
                activeSources: me.advancedCopy.get('activeSources'),
                scheduleOffset: me.advancedCopy.get('scheduleOffset'),
                companySetDescriptor: me.advancedCopy.get('companySetDescriptor')
            });

            const result = me.model.save();

            if (!result) {
                return me.ui.saveBtn.button('reset');
            }

            result
                .done(function () {
                    RivalIQ.execute('alert:info', 'Scheduled Report Saved');
                    me.closeOnSave = true;
                    me.ui.modal.modal('hide');
                })
                .fail(function () {
                    RivalIQ.execute('alert:warning', 'An error occurred saving this scheduled report. Please try again');
                    me.ui.saveBtn.button('reset');
                });
        },

        onBeforeShow: function () {
            const me = this;
            // save dirty copies to keep ui clean
            me.reportCopy = me.model.get('report').clone();
            // native Backbone collection cloning reuses their models, & we need a deeper clone
            me.emailsCopy = me.model.get('report').get('emails').cloneDeep();
            me.advancedCopy = me.model.get('advanced').clone();

            me.emailInput.show(new RivalIQ.views.EmailInput({
                namePrefix: 'report',
                collection: me.emailsCopy
            }));

            me.showAdvancedExportSettings();
        },

        showAdvancedExportSettings: function () {
            const me = this;
            const advanced = me.model.get('advanced');
            const report = me.model.get('report');
            const schedule = me.model.get('schedule');

            // last fallback to current landscape state - scheduled reports from before January 2017ish do not have these columns
            const defaultFocusCompanyId = advanced.get('focusCompanyId') || report.get('focusCompanyId') || RivalIQ.state.landscape.getFocusCompany().get('id');
            const defaultActiveSources = advanced.get('activeSources') || report.get('activeSources') || RivalIQ.state.account.getSupportedSourcesMask();
            const scheduleOffset = advanced.get('scheduleOffset') || schedule.get('offset');
            const defaultCompanySetDescriptor = advanced.get('companySetDescriptor') || report.get('state').companySetDescriptor;
            me.advanced.show(new RivalIQ.views.AdvancedExportSettings({
                model: me.advancedCopy,
                advancedSettingsEnabled: (report.get('advancedSettingsEnabled') !== false),
                defaultFocusCompanyId: defaultFocusCompanyId,
                defaultActiveSources: defaultActiveSources,
                scheduleOffset: scheduleOffset,
                defaultCompanySetDescriptor: defaultCompanySetDescriptor,
                labelClass: 'col-sm-3',
                formClass: 'col-sm-9',
                parentModal: me.ui.modal
            }));
        }
    });

    const LinkModal = Marionette.LayoutView.extend({
        template: '#reportsScheduledReportLinkTemplate',

        ui: {
            modal: '.modal',
            embeddableLinkBox: 'input[name="embeddableLink"]'
        },

        events: {
            'shown.bs.modal': 'onModalShown'
        },

        onModalShown: function () {
            const me = this;
            me.ui.embeddableLinkBox.select();
        }
    });

    const DeleteModal = Marionette.LayoutView.extend({
        template: '#reportsScheduledReportDeleteTemplate',

        ui: {
            deleteBtn: '.x-delete',
            modal: '.modal'
        },

        events: {
            'click @ui.deleteBtn': 'onDelete'
        },

        onDelete: function () {
            const me = this;
            me.ui.deleteBtn.button('loading');

            me.model.destroy()
                .done(function () {
                    RivalIQ.execute('alert:info', 'Scheduled report deleted');
                    me.ui.modal.modal('hide');
                })
                .fail(function () {
                    RivalIQ.execute('alert:warning', 'An error occurred deleting this scheduled report. Please try again');
                    me.ui.deleteBtn.button('reset');
                });
        }
    });

    const ReportNameView = Marionette.ItemView.extend({
        template: '#reportsScheduledReportNameTemplate',
        tagName: 'td',
        ui: {
            editLink: '.x-edit',
            linkLink: '.x-link',
            deleteLink: '.x-delete',
            overridenCompany: '.overriden-company'
        },

        events: {
            'click @ui.editLink': 'showEditModal',
            'click @ui.linkLink': 'showLinkModal',
            'click @ui.deleteLink': 'showDeleteModal'
        },

        onBeforeShow: function () {
            const me = this;
            const advanced = me.model.get('data').get('advanced');
            if (advanced && advanced.get('focusCompanyId')) {
                me.ui.overridenCompany.show();
            } else {
                me.ui.overridenCompany.hide();
            }
        },

        templateHelpers: function () {
            const me = this;
            const advanced = me.model.get('data').get('advanced');
            return {
                focusCompanyName: advanced.getFocusCompanyName(),
                hasGdsConnector: RivalIQ.state.account.get('plan').has_gds_connector
            };
        },

        serializeData: function () {
            const me = this;

            return me.model.get('data').toJSON();
        },

        showEditModal: function (e) {
            const me = this;
            e.stopPropagation();

            RivalIQ.execute('show:modal', new EditModal({
                model: me.model.get('data')
            }));
        },

        showLinkModal: function (e) {
            const me = this;
            e.stopPropagation();

            RivalIQ.execute('show:modal', new LinkModal({
                model: me.model.get('data')
            }));
        },

        showDeleteModal: function (e) {
            const me = this;
            e.stopPropagation();

            RivalIQ.execute('show:modal', new DeleteModal({
                model: me.model.get('data')
            }));
        }
    });

    const EnableView = Marionette.ItemView.extend({
        template: '#reportsScheduledReportEnableTemplate',
        tagName: 'td',
        className: 'cell-middle text-center',

        behaviors: {
            AttributeBuilder: {}
        },

        ui: {
            checkbox: 'input'
        },

        eventsNotToDebounce: {
            'click @ui.checkbox': 'onClick'
        },

        onClick: function (e) {
            e.stopPropagation();

            const me = this;
            const model = me.model.get('data');

            me.ui.checkbox.prop('disabled', true);

            model.save({
                disabled: !$(e.currentTarget).is(':checked')
            });
        },

        serializeData: function () {
            const me = this;
            return me.model.get('data').toJSON();
        }
    });

    const DetailsView = Marionette.LayoutView.extend({
        template: '#reportsReportScheduleDetailsTemplate',
        tagName: 'tr',
        className: 'x-details-view sub-row',

        regions: {
            reportList: '.x-report-list'
        },

        onRender: function () {
            const me = this;

            me.reportList.show(new App.widgets.ReportCenter({
                pollStatus: false,
                includeRecipients: true,
                includeTitle: false,
                dashboardModel: new Marionette.Dashboard.models.Model({
                    reportScheduleId: me.model.get('id')
                })
            }));
        }
    });

    const OverriddenChannelsView = Marionette.CollectionView.extend({
        tagName: 'td',
        className: 'cell-middle text-center',

        childView: Marionette.ItemView.extend({
            tagName: 'span',
            template: '#reportsScheduledReportChannelOverridesTemplate'
        }),

        emptyView: Marionette.ItemView.extend({
            template: '#reportsScheduledReportNoOverridesTemplate'
        }),

        initialize: function () {
            const me = this;
            const advanced = me.model.get('data').get('advanced');
            const currentActiveSources = advanced.get('activeSources') || 0;
            const channels = _.filter(advanced.getSupportedHideableSourceDetailsCollection(), function (channel) {
                return currentActiveSources & channel.mask;
            });
            me.collection = new Backbone.Collection(channels);
        }
    });

    const tableConfig = {
        className: 'table table-hover',
        emptyMsg: 'No scheduled exports',
        // TODO there is way too much jquery logic here. We should make the
        // table view more flexible and allow multiple rows per model
        onRowClick: function (model, e) {

            const $row = $(e.currentTarget);

            if ($row.next('.x-details-view').find('.collapse.in').length) {
                return $row.next().find('.collapse').collapse('hide');
            }

            if ($row.next('.x-details-view').length) {
                return $row.next().find('.collapse').collapse('show');
            }

            const details = new DetailsView({
                model: model
            }).render().el;

            $row.after(details);
            $row.next().find('.collapse').collapse('show');
        },
        rowClass: 'pointer',
        columns: [
            {
                className: 'cell-middle td-fa-2x',
                cellView: Marionette.ItemView.extend({
                    tagName: 'td',
                    className: 'cell-middle',
                    template: '#reportsScheduledReportIconTemplate',
                    templateHelpers: function () {
                        const me = this;
                        return {
                            icon: me.model.get('data').getIcon()
                        };
                    }
                })
            },
            {
                name: 'Report Name',
                className: 'col-md-4 cell-middle',
                cellView: ReportNameView
            },
            {
                name: 'Next Run',
                cellClassName: 'cell-middle',
                value: function (model) {

                    const timezone = RivalIQ.state.landscape.get('timezone');

                    return moment.utc(model.get('next_run_after'))
                        .tz(timezone)
                        .format('MMM DD YYYY h A (z)'); // format
                }
            },
            {
                name: 'Frequency',
                cellClassName: 'cell-middle',
                value: function (model) {
                    return s.titleize(model.get('schedule').get('period'));
                }
            },
            {
                name: 'Period',
                cellView: Marionette.ItemView.extend({
                    tagName: 'td',
                    className: 'cell-middle',
                    template: '#reportsScheduledReportDurationTemplate',
                    serializeData: function () {
                        const me = this;
                        const findById = function (id) {
                            return _.find(RivalIQ.enums.schedule.durations, {
                                id: id
                            });
                        };
                        return _.extend({
                            findById: findById
                        }, me.model.get('data').toJSON());
                    }
                })
            },
            {
                name: 'Company Set',
                cellView: Marionette.ItemView.extend({
                    tagName: 'td',
                    className: 'cell-middle',
                    template: '#reportsScheduledReportCompanyFilterTemplate',
                    serializeData: function () {
                        const me = this;
                        const advanced = me.model.get('data').get('advanced');
                        const report = me.model.get('data').get('report');

                        const state = report.get('state');
                        const defaultCompanySetDescriptor = state.companySetDescriptor;

                        return {
                            companySetName: advanced.getCompanySetName(advanced.getCompanySet(defaultCompanySetDescriptor))
                        };
                    }
                })
            },
            {
                name: 'Included Channels',
                cellView: OverriddenChannelsView
            },
            {
                name: 'Enabled',
                className: 'col-xs-2 col-sm-1 text-center',
                cellView: EnableView
            }
        ]
    };

    const ScheduledReports = widgets.ScheduledReports = RivalIQ.views.LoadingTableView.extend({
        config: tableConfig,
        loadData: function (callback) {
            const me = this;

            RivalIQ.export.data.reportSchedules.fetch().done(function (scheduledReports) {
                me.listenTo(scheduledReports, 'add', me.onRenderLoaded);
                me.listenTo(scheduledReports, 'remove', me.onRenderLoaded);
                me.listenTo(scheduledReports, 'sync', me.onRenderLoaded);

                me.model = new Backbone.Model({
                    data: scheduledReports
                });

                callback();
            });
        }
    });

    const Widget = RivalIQ.apps.Dashboard.models.Widget;
    const ScheduledWidget = Widget.extend({
        title: 'Scheduled Exports',
        description: RivalIQ.strings.schedule_info,
        view: ScheduledReports,
        exportFormats: [],
        viewMore: false
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SCHEDULED_REPORTS, ScheduledWidget);

}, window.s, window.moment);
